import { render, staticRenderFns } from "./recommendPro.vue?vue&type=template&id=497eec20&"
import script from "./recommendPro.vue?vue&type=script&lang=js&"
export * from "./recommendPro.vue?vue&type=script&lang=js&"
import style0 from "./recommendPro.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports